import { jsxs, jsx } from "react/jsx-runtime";
import IcoSpinner from "../../../assets/IconSpinner.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { useState, useCallback, useEffect } from "react";
import OTPInput from "../../../external/react-otp-input/lib/index.esm.js";
import TextField from "../TextField/TextField.js";
import FieldHelperText from "../FieldHelperText/FieldHelperText.js";
const isIncludeOnlyNumber = (str) => {
  return /^\d+$/.test(str);
};
const CodeField = ({
  classes,
  className,
  length,
  type = "number",
  onChange,
  onComplete,
  value = "",
  readonly = false,
  shouldAutoFocus,
  loading,
  disabled,
  error,
  helperText,
  displayHelperText,
  variant = "contained",
  t,
  helperTextClasses,
  isInputNum = true
}) => {
  const { themeClasses } = useThemePresetClasses("CodeField", classes, className, {
    variant
  });
  const [codeValue, setCodeValue] = useState(value);
  const handleChange = useCallback(
    (str) => {
      if (isInputNum && str.length > 0) {
        if (isIncludeOnlyNumber(str)) {
          setCodeValue(str);
        }
      } else {
        setCodeValue(str);
      }
    },
    [isInputNum]
  );
  useEffect(() => {
    setCodeValue(value);
  }, [value]);
  useEffect(() => {
    onChange == null ? void 0 : onChange(codeValue);
    if (String(codeValue).length === length && (isInputNum ? isIncludeOnlyNumber(codeValue) : true)) {
      onComplete == null ? void 0 : onComplete(codeValue);
    }
  }, [codeValue, length, isInputNum]);
  const onPaste = useCallback(
    (event) => {
      var _a;
      const data = (_a = event == null ? void 0 : event.clipboardData) == null ? void 0 : _a.getData("text");
      if (!data) {
        setCodeValue("");
        return;
      }
      if (isInputNum) {
        if (isIncludeOnlyNumber(data)) {
          if (data.length >= length) {
            const validData = data.substring(0, length);
            setCodeValue(validData);
          } else {
            setCodeValue(data);
          }
        } else {
          setCodeValue("");
        }
      } else {
        if (data.length >= length) {
          setCodeValue(data.substring(0, length));
        } else {
          setCodeValue(data);
        }
      }
    },
    [length, isInputNum]
  );
  useEffect(() => {
    if (loading) {
      const inputs = document.getElementsByClassName("code-input");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].setSelectionRange(0, 0);
        inputs[i].blur();
      }
    }
  }, [loading]);
  return /* @__PURE__ */ jsxs("div", { className: cn("w-fit", themeClasses == null ? void 0 : themeClasses.root), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: cn("relative flex w-fit", {
          "pointer-events-none": readonly
        }),
        onClick: (event) => {
          if (readonly) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        children: [
          loading && /* @__PURE__ */ jsx("div", { className: "animate-fade-in absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center", children: /* @__PURE__ */ jsx(IcoSpinner, { className: "h-1/2" }) }),
          /* @__PURE__ */ jsx(
            OTPInput,
            {
              shouldAutoFocus,
              value: codeValue,
              onChange: handleChange,
              onPaste,
              numInputs: length,
              renderSeparator: /* @__PURE__ */ jsx("div", { className: cn("w-1 flex-shrink-0") }),
              renderInput: (props) => /* @__PURE__ */ jsx(
                TextField,
                {
                  ...props,
                  onChange: (e) => {
                    var _a, _b;
                    if (isInputNum) {
                      if (isIncludeOnlyNumber(e.target.value)) {
                        (_a = props.onChange) == null ? void 0 : _a.call(props, e);
                      }
                    } else {
                      (_b = props.onChange) == null ? void 0 : _b.call(props, e);
                    }
                  },
                  onPaste: (e) => {
                    var _a, _b, _c;
                    const data = (_a = e == null ? void 0 : e.clipboardData) == null ? void 0 : _a.getData("text");
                    if (isInputNum) {
                      if (isIncludeOnlyNumber(data)) {
                        (_b = props.onPaste) == null ? void 0 : _b.call(props, e);
                      }
                    } else {
                      (_c = props.onPaste) == null ? void 0 : _c.call(props, e);
                    }
                  },
                  type,
                  inputMode: "numeric",
                  disabled: loading || disabled,
                  error,
                  classes: {
                    "root&": cn("h-[50px] min-[300px]:w-[44px] min-[360px]:w-[50px]", {
                      "opacity-80": loading
                    }),
                    "input&": cn(
                      "code-input !h-full !w-full px-0 text-center font-bold min-[300px]:!text-[32px] min-[360px]:!text-[30px]",
                      themeClasses == null ? void 0 : themeClasses.input
                    ),
                    "input_error&": "border-2"
                  }
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      FieldHelperText,
      {
        error,
        helperText,
        alwaysDisplay: displayHelperText,
        t,
        ...helperTextClasses,
        className: cn("mt-2", helperTextClasses == null ? void 0 : helperTextClasses.className)
      }
    )
  ] });
};
const CodeField$1 = CodeField;
export {
  CodeField$1 as default
};
